export default __webpack_public_path__ + "static/media/suitcase_openEMPTY.c54f6c42.png";